import { render, staticRenderFns } from "./AccountUserForm.vue?vue&type=template&id=6b144e80"
import script from "./AccountUserForm.vue?vue&type=script&lang=js"
export * from "./AccountUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports